export default "__VITE_ASSET__604837e3__"